var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.825 39.905L24.585 35.665C23.805 34.885 23.805 33.625 24.585 32.845C25.365 32.065 26.625 32.065 27.405 32.845L30.225 35.665L37.305 28.585C38.085 27.805 39.345 27.805 40.125 28.585C40.905 29.365 40.905 30.625 40.125 31.405L31.645 39.885C30.865 40.685 29.605 40.685 28.825 39.905Z",
    fill: "#053915"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 38,
    y2: 12,
    stroke: "#053915",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 22,
    x2: 38,
    y2: 22,
    stroke: "#053915",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 34,
    x2: 18,
    y2: 34,
    stroke: "#053915",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeLast);
export default __webpack_public_path__ + "static/media/make_last.4295fe77d7c4c4e90afd2b880a1f671a.svg";
export { ForwardRef as ReactComponent };